module.exports = __webpack_public_path__ + "img/辛集制革.605d0a63.jpg";